import Vue, {
	router,
	store,
	settings,
	menu,
	nprogress,
} from "@/system/config/vue";

import app from "./index";

const vm = new Vue({
	data() {
		return {
			web: true,
		};
	},
	async created() {
		Vue.prototype.$main = this;

		if (this.$gestios.connected) {
			if (settings) this.$store.dispatch("SETTINGS/CUSTOM", settings);
			if (menu) this.$store.dispatch("SETTINGS/MENU", menu);

			const apps = await this.$gestios.$cache.apps();
			if (Object.keys(apps).length === 0) {
				const apps = await this.$gestios.apps();
				if (!apps.ok) {
					this.$router.replace({
						name: "_500",
						query: { error: apps.message },
					});
				}
			}
		}
	},
	router,
	store,
	nprogress,
	render: (h) => h(app),
}).$mount("#app");

if (process.env.VUE_APP_ENVIRONMENT === "development") {
	global.vm = vm;
}

export default vm;
